export const HINT_TIMEOUT = 10000;
export const HINT_SEARCH_INTERVAL = 1000;

export const SELECTORS = {
  OFFER_PLUS_BUTTON_NAME: 'offer-plus-button',
  HOME_CONTAINER_ID: 'home-container',
};
